import { apiBusSchedBaseURL } from '../../authentication/Global';
import { authenticationCentral } from '../../authentication/Authentication';
import { API, HTTPMethod, ContentType } from '../APICentral';

const regionsApiRoutes = {
    list: apiBusSchedBaseURL + "regions/",
};

export class RegionAPI {
    static list() {
        return API.authenticatedRequest({
            url: regionsApiRoutes.list,
            method: HTTPMethod.GET,
            contentType: ContentType.JSON,
            token: authenticationCentral.accessToken
        });
    }
}
